export class TomlGenerator {
  static generateToml(tokenData, issuerAddress) {
    const domain = tokenData.domain || 'xpad.space';
    
    // Format any social media handles properly
    const twitterHandle = tokenData.twitter ? tokenData.twitter.replace('@', '').trim() : '';
    const telegramHandle = tokenData.telegram ? tokenData.telegram.replace('@', '').trim() : '';
    
    return `[[ISSUERS]]
address = "${issuerAddress}"
name = "${tokenData.name}"
${tokenData.description ? `desc = "${tokenData.description}"` : ''}
${domain ? `domain = "${domain}"` : ''}

[[TOKENS]]
issuer = "${issuerAddress}"
currency = "${tokenData.symbol}"
name = "${tokenData.name}"
${tokenData.description ? `desc = "${tokenData.description || `${tokenData.name} is a token on the XRP Ledger.`}"` : ''}
${tokenData.icon ? `icon = "${tokenData.icon}"` : ''}
${tokenData.banner ? `banner = "${tokenData.banner}"` : ''}

${tokenData.website ? `[[TOKENS.WEBLINKS]]
url = "${tokenData.website}"
type = "website"
title = "Official Website"
` : ''}

${twitterHandle ? `[[TOKENS.WEBLINKS]]
url = "https://twitter.com/${twitterHandle}"
type = "socialmedia"
title = "Twitter"
` : ''}

${telegramHandle ? `[[TOKENS.WEBLINKS]]
url = "https://t.me/${telegramHandle}"
type = "socialmedia"
title = "Telegram"
` : ''}`;
  }

  static downloadToml(content, symbol) {
    const blob = new Blob([content], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${symbol.toLowerCase()}.toml`;
    a.click();
    window.URL.revokeObjectURL(url);
  }

  static async verifyTomlUrl(domain = 'xpad.space') {
    try {
      // Try direct URL first
      const directUrl = `https://${domain}/.well-known/xrp-ledger.toml`;
      
      // Use a timestamp parameter to avoid caching issues
      const response = await fetch(`${directUrl}?t=${Date.now()}`);
      
      if (response.ok) {
        console.log(`TOML found at: ${directUrl}`);
        
        // Also check if we can find the specific token in the TOML
        const tomlContent = await response.text();
        return {
          success: true,
          url: directUrl,
          content: tomlContent
        };
      }
      
      console.error(`TOML not found at ${directUrl} (status: ${response.status})`);
      return {
        success: false,
        error: `TOML file not found (status: ${response.status})`
      };
    } catch (error) {
      console.error('Error verifying TOML:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
  
  static getTomlHostedUrl(tokenSymbol) {
    return `https://xpad.space/.well-known/xrp-ledger.toml#${tokenSymbol.toLowerCase()}`;
  }
} 